import { useMemo } from "react";
import { enUS, es } from "date-fns/locale";
import type { Locale } from "date-fns";
import { useLocale } from "./LocaleProvider";

export function useLocaleFormat() {
  const { locale } = useLocale();
  return useMemo(() => {
    const isEn = locale === "en";
    const numberLocale = isEn ? "en-US" : "es-CL";
    const dateFnsLocale: Locale = isEn ? enUS : es;
    return {
      locale,
      numberLocale,
      dateFnsLocale,
      formatNumber: (value: number) => value.toLocaleString(numberLocale),
      formatDate: (value: Date, options?: Intl.DateTimeFormatOptions) =>
        value.toLocaleDateString(numberLocale, options),
    };
  }, [locale]);
}
